import { z } from 'zod';
import { isValidRut } from '../common/rut.js';
export const DOT_DOCUMENT_TYPES = [33, 34, 39, 41, 52, 56, 61];
export const dotDocumentTypeSchema = z.union([
    z.literal(33),
    z.literal(34),
    z.literal(39),
    z.literal(41),
    z.literal(52),
    z.literal(56),
    z.literal(61),
]);
export const dotScopeSchema = z
    .object({
    environment: z.enum(['certification', 'production']),
    emitterRut: z
        .string()
        .regex(/^\d{1,8}-[\dK]$/)
        .refine(isValidRut, 'RUT emisor inválido.'),
})
    .strict();
const policyFields = {
    documentType: dotDocumentTypeSchema,
    automaticReplenishment: z.boolean(),
    batchSize: z.number().int().min(1).max(10000),
    minimumRemaining: z.number().int().min(0).max(9999),
};
export const dotFolioPolicyWriteSchema = z
    .object({
    ...policyFields,
    expectedRevision: z.number().int().nonnegative(),
})
    .strict()
    .refine((v) => v.minimumRemaining < v.batchSize, {
    message: 'El umbral debe ser menor que el tamaño del bloque.',
    path: ['minimumRemaining'],
});
export const dotFolioPolicySchema = z
    .object({
    ...policyFields,
    revision: z.number().int().nonnegative(),
    updatedBy: z.string().nullable(),
    updatedAt: z.string().datetime().nullable(),
})
    .strict();
export const dotFolioRequestWriteSchema = z
    .object({
    documentType: dotDocumentTypeSchema,
    quantity: z.number().int().min(1).max(10000),
})
    .strict();
export const dotFolioRequestSchema = z
    .object({
    id: z.string().uuid(),
    documentType: dotDocumentTypeSchema,
    quantity: z.number().int().positive(),
    status: z.literal('awaiting_provider'),
    requestedBy: z.string(),
    createdAt: z.string().datetime(),
})
    .strict();
export const dotFolioOverviewSchema = z
    .object({
    scope: dotScopeSchema.nullable(),
    externalOperationsEnabled: z.literal(false),
    policies: z.array(dotFolioPolicySchema),
    requests: z.array(dotFolioRequestSchema),
})
    .strict();
export const DOT_FOLIO_PATHS = {
    overview: '/invoicing/dot/folios',
    policy: '/invoicing/dot/folios/policy',
    requests: '/invoicing/dot/folios/requests',
};
export function defaultDotFolioPolicy(documentType) {
    return {
        documentType,
        automaticReplenishment: false,
        batchSize: 100,
        minimumRemaining: 20,
        revision: 0,
        updatedBy: null,
        updatedAt: null,
    };
}
/** A planning decision only. Unknown stock never triggers another reservation. */
export function shouldReplenishDotFolios(policy, available, hasOutstandingRequest) {
    return (policy.automaticReplenishment &&
        available !== null &&
        Number.isSafeInteger(available) &&
        available >= 0 &&
        available <= policy.minimumRemaining &&
        !hasOutstandingRequest);
}
//# sourceMappingURL=dot.js.map